import React from 'react'

export const CircularPlay: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M39.5 77C60.2107 77 77 60.2107 77 39.5C77 18.7893 60.2107 2 39.5 2C18.7893 2 2 18.7893 2 39.5C2 60.2107 18.7893 77 39.5 77Z"
        fill="#0E101A"
        fillOpacity="0.2"
        stroke="white"
        strokeWidth="2.51677"
      />
      <path
        d="M58.1776 35.9772C60.8896 37.543 60.8896 41.4571 58.1776 43.0229L33.2111 57.4373C30.4992 59.003 27.1094 57.0459 27.1094 53.9144V25.0857C27.1094 21.9542 30.4992 19.9971 33.2111 21.5628L58.1776 35.9772Z"
        fill="white"
      />
    </svg>
  )
}
